import { Html } from "@react-three/drei";
import React from "react";
import { Segment } from "semantic-ui-react";
import "../Css/HireMeTab.css";
import { currentLang, Localizator } from "../utils/lang";
const textContents = [
  {
    firstLetter: "Why",
    title: "you should hire me",
    content: Localizator("job_why_context"),
  },
  {
    firstLetter: "What",
    title: "can I do for you",
    content: Localizator("job_what_context"),
  },
  {
    firstLetter: "When",
    title: "can I go to work",
    content: Localizator("job_when_context"),
  },
  {
    firstLetter: "How",
    title: "to contact me",
    content: Localizator("job_how_context"),
  },
];

function HireMeTab() {
  return (
    <>
      <div className="hmt__root">
        <div className="hmt__bg_mask"></div>
        <Segment className="hmt__container">
          <p className="hmt__hireme-text">HIRE ME ! </p>

          <div className="hmt__content-container">
            {/* 標題 */}
            <p>#Hello World</p>

            {textContents.map((data, _) => {
              return (
                <div className="hmt__list_item">
                  <div className="hmt__list-title-container">
                    <p className="hmt__list-title">{data.firstLetter}</p>
                    <p className="hmt__list-text">{data.title}</p>
                  </div>
                  <div>
                    <p className="hmt__list-content">{data.content}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="hmt__mail">
            <a href="mailto: lontooneforbusiness@gmail.com">
              lontooneforbusiness@gmail.com
            </a>
          </div>
        </Segment>
      </div>
    </>
  );
}

export default HireMeTab;
